import { render, staticRenderFns } from "./Template240.vue?vue&type=template&id=0b03b090"
import script from "./Template240.vue?vue&type=script&lang=js"
export * from "./Template240.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports